/**
 * The Night Owl Terms (TERMS at the repository root). Whoever sets up a business agrees to them
 * during setup, and owners and admins of a business that hasn't agreed to this version are asked
 * once before they continue. Change this, and the version line in TERMS, whenever TERMS changes,
 * so everyone agrees again.
 */
export const TERMS_VERSION = "2026-10-21";
